import { useApi } from "@/lib/api";

export const LatestEntries = ({ count = 5, testId = "latest-entries" }) => {
  const { data } = useApi("/arrivages");
  const tracks = Array.isArray(data) ? data.slice(0, count) : [];
  return (
    <ol className="mt-10 border-t border-white/10 min-w-0" data-testid={testId}>
      {tracks.map((t) => (
        <li key={t.id} className="flex items-baseline gap-6 py-4 border-b border-white/10">
          <span className="font-display text-3xl text-primary w-10 shrink-0">{String(t.rank).padStart(2, "0")}</span>
          <div className="min-w-0">
            <p className="text-white font-semibold truncate">{t.title}</p>
            <p className="text-zinc-400 text-sm truncate">{t.artist}</p>
          </div>
        </li>
      ))}
    </ol>
  );
};
